import { LFlex } from "@components";
import { PricingTier } from "@store/generalTypes";
import { isEmpty } from "lodash";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const PricingTable = ({ pricingTiers = [], loading }: PricingTableProps): JSX.Element => {
    return (
        <LFlex alignCenter justifyCenter className="has-text-ldark-gray mt-5 minw-100">
            <div className="columns mt-5 has-background-lightest-blue has-text-weight-semibold minw-50">
                <div className="column is-one-quarter has-text-right"># of Assessments</div>
                {loading || isEmpty(pricingTiers) ? (
                    <SkeletonWrapper />
                ) : (
                    pricingTiers.map((pt) => <SimplePricingTableCell key={pt.name} value={pt.name} />)
                )}
            </div>
            <div className="columns minw-50 has-background-white">
                <div className="column is-one-quarter has-text-right">Unit Price</div>
                {loading || isEmpty(pricingTiers) ? (
                    <SkeletonWrapper />
                ) : (
                    pricingTiers.map((pt) => <FormattedPricingTableCell key={pt.name} value={`$${pt.unitPrice}`} />)
                )}
            </div>
            <div className="columns minw-50 has-background-white">
                <div className="column is-one-quarter has-text-right">Savings (%)</div>
                {loading || isEmpty(pricingTiers) ? (
                    <SkeletonWrapper />
                ) : (
                    pricingTiers.map((pt) => (
                        <SimplePricingTableCell key={pt.name} value={pt.discount ? `${pt.discount}%` : "-"} />
                    ))
                )}
            </div>
        </LFlex>
    );
};

const SkeletonWrapper = (): JSX.Element => {
    return (
        <div className="column">
            <Skeleton />
        </div>
    );
};

interface PricingTableProps {
    pricingTiers: PricingTier[];
    loading: boolean;
}

const SimplePricingTableCell = ({ value }: SimplePricingTableCellProps): JSX.Element => {
    return (
        <div className="column has-text-centered">
            <span>{value}</span>
        </div>
    );
};

interface SimplePricingTableCellProps {
    value: string;
}

const FormattedPricingTableCell = ({ value }: FormattedPricingTableCellProps): JSX.Element => {
    return (
        <div className="column has-text-centered">
            <span className="has-text-green has-text-weight-bold">
                <span>{value}</span>
            </span>
            /ea
        </div>
    );
};

interface FormattedPricingTableCellProps {
    value: string | number;
}
